import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Input from 'components/atoms/Input';
import Label from 'components/atoms/Label';
import { bindActionCreators, Dispatch } from 'redux';
import { setLayoutAction } from 'store/actions/layoutActions';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { cloneObject, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface LabelDrawingModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];
    id?: string;
    data: any;
    actions: ActionsType | undefined;
}

interface LabelDrawingModelState {
    errors: object;
    data: any | null;
}

class LabelDrawingModel extends Component<LabelDrawingModelProps, LabelDrawingModelState> {
    constructor(props: LabelDrawingModelProps) {
        super(props);
        this.state = {
            data: cloneObject(props.data),
            errors: {},
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm(this.state.data);
        this.props.actions?.onCancel();
    };
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">
                            {this.props.data.name ? translate('update label') : translate('create label')}
                        </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <FormGroup required={false}>
                        <Label>{translate('feature name')}</Label>
                        <Input
                            name="name"
                            autoFocus
                            placeholder="Name"
                            value={this.state.data.name}
                            onChange={this.handleChange}
                        />
                    </FormGroup>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const LabelDrawingModelStateToProps = (state: RootState) => ({});

const LabelDrawingModelDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(LabelDrawingModelStateToProps, LabelDrawingModelDispatchToProps)(LabelDrawingModel);
